class childrenComponent {
  constructor($scope, $state, $rootScope, localStorageService, CHILDREN_COMPONENT_CONSTANTS, authService) {
    'ngInject';

    let userId = localStorageService.get('user_id');
    let schoolId = localStorageService.get('school_id');

    $scope.showAllComponent = true;
    $scope.parentStateArray = ['parentPortalHome', 'parentFeedback', 'parentFees', 'parentLibrary', 'trackSchoolBus', 'studentActivity', 'publishedReports', 'medicalFeatureList', 'getAvailability', 'archiveResources'];
    $scope.$watch(function () {
      return $state.$current.name
    }, function (newVal, oldVal) {
      $scope.isParent = _.contains($scope.parentStateArray, newVal)
      localStorageService.set('isParent', $scope.isParent);
      showChild();
      $scope.showAllComponent = (newVal === "authdashboard") ? false : true
    });

    this.$onInit = () => {
      $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
      if (!$rootScope.isLoggedIn) {
        $state.go("login", {}, { reload: true })
      } else {
        authService.callAPI(CHILDREN_COMPONENT_CONSTANTS.API_GET_PARENT_DETAILS + userId, "GET", {}, function (response) {
          if (response.result && response.result.data && response.result.data.details) {
            try {
              $scope.personData = response.result.data.details;
              showChild();
            } catch (ex) {
              console.log(ex);
            }
          } else {
            toastr.error('Network Error. Please try later');
          }
          _.defer(function () {
            $scope.$apply();
          });
        });
      }
    }

    function showChild() {
      let prnt = localStorageService.get('isParent');
      if (prnt === undefined || prnt === null)
        return false;
      $scope.isParent = prnt;
      if ($scope.isParent === false) {
        $scope.showAllComponent = false;
        return false;
      }
      $scope.showAllComponent = ($state && $state.current && $state.current.name === "authdashboard") ? false : true
      if (!schoolId) {
        toastr.error("No school id found")
      }
      if ($scope.personData && $scope.personData.child) {
        if ($scope.personData.child.length > 0) {
          let myChildIds = _.pluck($scope.personData.child, "_id")
          myChildIds = _.compact(_.flatten(myChildIds))
          if (myChildIds) {
            authService.callAPI(CHILDREN_COMPONENT_CONSTANTS.API_GET_PARENT_CHILD_DETAILS + JSON.stringify(myChildIds), "GET", {}, function (response) {
              if (response.result && response.result.data && response.result.data.details) {
                try {
                  if($state.params.student_id)
                    localStorageService.set('st_id', $state.params.student_id)
                  $scope.childrenList = response.result.data.details
                  if (localStorageService.get('st_id')) {
                    _.each($scope.childrenList, function (doc) {
                      doc.active = false
                        if (doc.user_id === localStorageService.get('st_id')) {
                          doc.active = true;
                          localStorageService.set({
                            portalData: {
                              session_id: doc.session_id,
                              curriculum_id: doc.curriculum_id,
                              class_id: doc.class_id,
                              batch_id: doc.batch_id,
                              session: doc.session,
                              curriculum: doc.curriculum,
                              class: doc.class,
                              batch: doc.batch
                            }
                          })
                          localStorageService.set("st_session_id", doc.session_id)
                          localStorageService.set("st_curriculum_id", doc.curriculum_id)
                          localStorageService.set("st_class_id", doc.class_id)
                          localStorageService.set("st_batch_id", doc.batch_id)
                          localStorageService.set("st_name", doc.name)
                        }
                    })
                  } else {
                    localStorageService.set({
                      portalData: {
                        session_id: $scope.childrenList[0].session_id,
                        curriculum_id: $scope.childrenList[0].curriculum_id,
                        class_id: $scope.childrenList[0].class_id,
                        batch_id: $scope.childrenList[0].batch_id,
                        session: $scope.childrenList[0].session,
                        curriculum: $scope.childrenList[0].curriculum,
                        class: $scope.childrenList[0].class,
                        batch: $scope.childrenList[0].batch
                      }
                    })
                    localStorageService.set("st_id", $scope.childrenList[0].user_id)
                    localStorageService.set("st_session_id", $scope.childrenList[0].session_id)
                    localStorageService.set("st_curriculum_id", $scope.childrenList[0].curriculum_id)
                    localStorageService.set("st_class_id", $scope.childrenList[0].class_id)
                    localStorageService.set("st_batch_id", $scope.childrenList[0].batch_id)
                    localStorageService.set("st_name", $scope.childrenList[0].name)
                    $scope.childrenList[0].active = true;
                  }
                } catch (ex) {
                  console.log(ex);
                }
              } else {
                toastr.error('Network Error. Please try later');
              }
              localStorageService.set("childrenList", $scope.childrenList)
              console.log($scope.childrenList)
              _.defer(function () {
                $scope.$apply();
              });
            });
          }
        }
      }
    }

    $scope.saveStudentDetails = (child) => {
      if (child && child._id) {
        if (!child.active || child.active === false) {
          localStorageService.set({
            portalData: {
              session_id: child.session_id,
              curriculum_id: child.curriculum_id,
              class_id: child.class_id,
              batch_id: child.batch_id,
              session: child.session,
              curriculum: child.curriculum,
              class: child.class,
              batch: child.batch
            }
          })
          localStorageService.set("st_session_id", child.session_id)
          localStorageService.set("st_curriculum_id", child.curriculum_id)
          localStorageService.set("st_class_id", child.class_id)
          localStorageService.set("st_batch_id", child.batch_id)
          localStorageService.set("st_id", child.user_id)
          localStorageService.set("st_name", child.name)

          localStorageService.set("st_session_name", child.name)
          localStorageService.set("st_name", child.name)
          localStorageService.set("st_name", child.name)
          localStorageService.set("st_name", child.name)
          child._id = child.user_id
          child.child_name = child.name
          localStorage.setItem('childDetails', JSON.stringify(child))
          toastr.success(child.name)
          if ($state.$current.name == "getAvailability") {
            $rootScope.$emit("getAllAvailablityList", {})
          }
          if ($scope.childrenList.length > 0) {
            _.each($scope.childrenList, function (doc) {
              doc.active = false
              if (doc.user_id === child.user_id)
                doc.active = true
            })
          }
        }
      }
    }

    $scope.viewSelectedChild = function (data) {
      $scope.showAllComponent = false
      if (data === 'showSelected') {
        $scope.showAllComponent = false
        $scope.showComponent = true
      }
    }

    $scope.viewAllChild = function (data) {
      $scope.showComponent = true
      $scope.showAllComponent = false
      if (data === 'showAll') {
        $scope.showAllComponent = true
        $scope.showComponent = false
      }
    }
  }
}

export default childrenComponent;


// WEBPACK FOOTER //
// ./src/app/parent-portal/controller/childrenComponentController.js